import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { UserWiseInvoiceCountType } from "../../../redux/listing/listingTypes";
import { formatDate } from "../../../utils/commonFunctions";


type AppProps = {
  tableHeaders:TableHeadersType[];
 data:UserWiseInvoiceCountType[]|[]
}

const UserWiseInvoiceCountTable = ({
  tableHeaders,
  data
}: AppProps) => {

return <>{data?.map((dataItem: any) => {
    return <tr className="text-left">
      {tableHeaders?.length && tableHeaders?.map((item: any) => {
          if (item.value === "date") {
            return (
              <td>
                {formatDate(dataItem["date"])}
              </td>
            );
          }
     else if (dataItem[item.value]){
        return<td >{dataItem[item?.value]}</td>
       }
       
     
      
      
      else{
        return <td> --/-- </td>
       }
      })}
    </tr>
  })}
  </>
};

export default UserWiseInvoiceCountTable;